// libs
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

// Props and Context
const propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.string,
};
const defaultProps = {
  description: '',
};

function LinedTitle({ title, description }) {
  return (
    <div className="lined-title">
      <h1 className="lined-title__title">
        {title}
      </h1>
      {description &&
      <p className="lined-title__description">
        {description}
      </p>
      }
    </div>
  );
}

LinedTitle.propTypes = propTypes;
LinedTitle.defaultProps = defaultProps;

export default LinedTitle;



// WEBPACK FOOTER //
// ./src/app/components/tools/linedTitle/LinedTitle.js